export default __webpack_public_path__ + "static/media/logo.e0236261.svg";